"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import homeIcon from "@/public/images/home.svg";
import leftArrowIcon from "@/public/images/leftArrow.svg";
import calendarIcon from "@/public/images/calendar.svg";
import facultyExistIcon from "@/public/images/facultyExist.svg";
import blackCapIcon from "@/public/images/blackCap.svg";
import viewIcon from "@/public/images/view.svg";
import timeIcon from "@/public/images/time.svg";
import costIcon from "@/public/images/cost.svg";
import latestIcon from "@/public/images/latest.svg";
import locationGreyIcon from "@/public/images/locationGrey.svg";
import FaviconIcon from "@/public/Favicon.svg";
import fireIcon from "@/public/images/fire.svg";
import ShowImage from "@/public/icons/ShoImage.svg";
import { format } from "date-fns";
import { ar, enUS } from "date-fns/locale";
import { DialogDemo } from "@/components/shared/Dialog/ImaageDialog";
import { Faculty } from "@/types/Faculty";
import ShareButtons from "@/components/shared/ShareButtons";
import { useTranslate } from "@/components/base/providers/TranslateProv";
import { Link } from "lucide-react";
import MyLink from "@/components/shared/myLink/MyLink";
import ImageNo from "@/public/images/no-image-icon-23492.png";
import ApplicationInformation from "./ApplicationInformation";
import { formatNumber } from "@/utils/format viwes number/formatNumber";
import { toast } from "react-toastify";
import {
  useAddToUniversitiesFavoritesMutation,
  useRemoveToUniversitiesFavoritesMutation,
} from "@/redux/features/api/Favorites/favoritesApiSlice";
import { getCookie } from "cookies-next";

interface HeaderSectionProps {
  data: Faculty;
  locale: "ar" | "en";
}

const HeaderSection: React.FC<HeaderSectionProps> = ({ data, locale }) => {
  const {
    name,
    image,
    specialization_count,
    short_description,
    viewing_number,
    created_at,
    updated_at,
    specialization,
    university,
    favorite,
  } = data;

  const {
    video_link,
    map_links,
    images,
    name: university_name,
    image: university_image,
  } = data.university;
  const [isFavorite, setIsFavorite] = useState<boolean>(favorite || false);
  const [addToFavorites, {}] = useAddToUniversitiesFavoritesMutation();
  const [removeToFavorites, {}] = useRemoveToUniversitiesFavoritesMutation();

  const handleAddToFavorites = async () => {
    const token = getCookie("token");

    if (token) {
      if (data?.id) {
        try {
          await addToFavorites({ faculty_id: data.id }).unwrap();
          toast.success(
            locale === "ar"
              ? "تمت الاضافة الى المفضلات بنجاح"
              : "Added to favorites successfully"
          );
          setIsFavorite(true);
        } catch (error) {
          toast.error(locale === "ar" ? "حدث خطا ما " : "An error occurred");
          console.error("Error adding to favorites:", error);
        }
      }
    } else {
      toast.error(
        locale === "ar" ? "من فضلك سجل دخول اولا" : "Please login first"
      );
    }
  };
  const handleRemoveToFavorites = async () => {
    if (data?.id) {
      try {
        await removeToFavorites({ faculty_id: data.id }).unwrap();
        toast.success(
          locale === "ar"
            ? "تم الحذف من المفضلات بنجاح"
            : "Removed from favorites successfully"
        );
        setIsFavorite(false);
      } catch (error) {
        toast.error(locale === "ar" ? "حدث خطا ما " : "An error occurred");
        console.error("Error adding to favorites:", error);
      }
    }
  };
  const [show, setshow] = useState<string>(
    images?.length > 0 ? images[0].image : ImageNo
  );

  const [bigImage, setbigImage] = useState<string>("");

  useEffect(() => {
    if (images?.length > 0 && show !== "video") {
      const interval = setInterval(() => {
        setshow((prevShow) => {
          const currentIndex = images.findIndex(
            (img) => img?.image === prevShow
          );
          const nextIndex = (currentIndex + 1) % images?.length;
          return images[nextIndex]?.image;
        });
      }, 3000);

      return () => clearInterval(interval); // Cleanup on unmount
    }
  }, [images, show]);

  // Format dates based on locale
  const formatDate = (dateString: string | undefined, locale: "ar" | "en") => {
    if (!dateString) return "0";
    const date = new Date(dateString);
    return format(date, "PPP", { locale: locale === "ar" ? ar : enUS });
  };

  return (
    <div className="container flex flex-wrap md:flex-nowrap items-center gap-5 relative bgLinear ">
      <div className=" md:min-w-[460px] w-full  md:max-w-[460px]  bg-white  rounded-[10px] p-4 flex items-center justify-center mx-auto flex-col gap-[10px]  h-fit lg:sticky lg:top-10">
        {" "}
        {show === "video" ? (
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${new URLSearchParams(
              new URL(video_link)?.search
            )?.get("v")}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full min-h-[300px] max-h-[300px] object-contain"
          ></iframe>
        ) : (
          <div className="relative max-w-[420px]  md:min-h-[172px] max-h-[172px] overflow-hidden ">
            <Image
              src={show}
              alt={`University Image`}
              className="w-full h-full object-cover rounded"
              width={300}
              height={300}
              loading="lazy"
            />
            <div
              onClick={() => setbigImage(show)}
              className="absolute top-5 right-5 w-[420px]  min-h-[172px] max-h-[172px]"
            >
              <DialogDemo
                open={<Image src={ShowImage} alt="Show Image" />}
                src={bigImage}
              />
            </div>
          </div>
        )}
        {images?.length > 0 && (
          <div className="flex items-center gap-[10px] overflow-auto px-2 custom-scroll-bar">
            <div
              onClick={() => setshow("video")}
              style={{ cursor: "pointer" }}
              className="w-[97px] h-[61px] object-contain mb-3"
            >
              <iframe
                // style={
                //   bigImage === "video" ? { border: "4px solid #0099FF" } : {}
                // }
                width="164px"
                height="105px"
                src={`https://www.youtube.com/embed/${new URLSearchParams(
                  new URL(video_link).search
                ).get("v")}`}
                title="YouTube video player"
                allowFullScreen
                className="pointer-events-none w-[97px] h-[61px] rounded-lg mb-3"
              ></iframe>
            </div>

            {images?.map((img, index) => {
              if (img.image) {
                return (
                  <Image
                    onClick={() => setshow(img.image)}
                    key={index}
                    src={img.image}
                    alt={`University Image ${index}`}
                    className="w-[97px] h-[61px] object-cover rounded-[10px] cursor-pointer mb-3"
                    style={
                      show == img.image ? { border: "2px solid #0099FF" } : {}
                    }
                    width={164}
                    height={105}
                    loading="lazy"
                  />
                );
              }
              return null;
            })}
          </div>
        )}
        <div className="grid grid-cols-3 gap-2 w-full">
          <div className=" bg-[#F8F9FA]  p-2 flex flex-col items-center justify-center gap-2">
            <Image src={calendarIcon} alt="Calendar Icon" />
            <p className="text-14 text-darkText">
              {locale === "ar" ? "تأسيس الجامعة" : "Founding Year"}
            </p>
            <p className="text-14 text-center text-[#ACB5BB] font-[600]">
              {university?.founding_date}
            </p>
          </div>
          <div className=" bg-[#F8F9FA]  p-2 flex flex-col items-center justify-center gap-2">
            <Image src={blackCapIcon} alt="Black Cap Icon" />
            <p className="text-14 text-darkText">
              {locale === "ar" ? "التخصصات" : "Programmes"}
            </p>
            <p className="text-14 text-center text-[#ACB5BB] font-[600]">
              {specialization_count
                ? specialization_count
                : specialization?.length
                ? specialization?.length
                : "0"}
            </p>
          </div>
          <div className="bg-[#F8F9FA] rounded-[10px] p-2 flex flex-col items-center justify-center gap-2">
            <Image src={costIcon} alt="Cost" />
            <p className="text-14 text-darkText text-center">
              {locale === "ar" ? "التكلفة السنوية" : "Annual cost"}
            </p>
            <p className="text-14  text-[#ACB5BB] font-[600] text-center">
              {data?.expenses[locale]}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-between w-full gap-3">
          {/* <Link
           // Link to faculty application
            href={"#"}
            target="_blank"
          >
            {locale === "ar"
              ? "رابط التقديم للكليه"
              : "Faculty application link"}
            رابط التقديم للكليه
          </Link> */}
          <ApplicationInformation university={university}>
            <div className="bg-primaryColor py-3  rounded-[10px] text-20 text-white flex items-center justify-center flex-1">
              {locale === "ar" ? "معلومات التقديم" : "Application Information"}
            </div>
          </ApplicationInformation>
          <ShareButtons
            isFavorite={isFavorite}
            handleAddToFavorites={handleAddToFavorites}
            handleRemoveToFavorites={handleRemoveToFavorites}
            title={name[locale]}
          />
        </div>
      </div>

      <div className="flex flex-col gap-8 w-full  ">
        <div className="flex items-center gap-3">
          <MyLink href="/" className="flex items-center gap-1.5 hover:text-primaryColor transition-colors">
            <Image src={homeIcon} alt="Home Icon" />
            <span className="text-12 text-descriptionText hover:text-primaryColor transition-colors">
              {locale == "ar" ? "الرئيسية" : " Home"}
            </span>
          </MyLink>
          <Image src={leftArrowIcon} alt="Left Arrow Icon" />
          <MyLink href="/faculities" className="hover:text-primaryColor transition-colors">
            <span className="text-12 text-descriptionText hover:text-primaryColor transition-colors">
              {locale == "ar" ? "الكليات" : " Faculties"}
            </span>
          </MyLink>
          <Image src={leftArrowIcon} alt="Left Arrow Icon" />
          <p className="text-12 text-descriptionText">{`${name[locale]}`}</p>
        </div>
        <div className="flex items-center gap-3">
          {image && (
            <Image
              src={image}
              alt="University Image"
              className="h-[96] object-contain"
              width={96}
              height={96}
            />
          )}
          <div className="flex items-center justify-center gap-4 ">
            <div>
              <Image
                src={university_image || ""}
                width={100}
                height={100}
                alt=" university_image"
                className="rounded-xl"
              />
            </div>
            <div className="">
              <p className="text-30 text-darkText font-[500]">{`${name[locale]} - ${university_name[locale]}`}</p>
              <div className="flex items-center gap-3">
                <Image src={locationGreyIcon} alt="Location Grey Icon" />
                <p className="text-16 text-descriptionText">
                  {map_links && map_links[0]?.title[locale]}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-5">
          <div className="flex items-center gap-3 flex-wrap">
            {data?.nominate_it ? (
              <div className="bg-white py-2 px-7 rounded-full flex items-center gap-3">
                <Image src={FaviconIcon} alt="favicon" width={20} height={20} />
                <p className="text-14 text-darkText">
                  {locale === "ar" ? "نرشح" : "Nominate"}
                </p>
              </div>
            ) : (
              ""
            )}
            {data?.trending_now || data?.trending_now_for_all ? (
              <div className="bg-white py-2 px-7 rounded-full flex items-center gap-3">
                <Image src={fireIcon} alt="Fire Icon" />
                <p className="text-14 text-darkText">
                  {locale === "ar" ? "رائج الآن" : "Trending Now"}
                </p>
              </div>
            ) : (
              ""
            )}
          </div>
          <p className="text-14 text-darkText bg-white py-2 px-7 rounded-full">
            {data?.university?.type[`name_${locale}`]
              ? data?.university?.type[`name_${locale}`]
              : data?.university?.type?.name_ar}
          </p>
        </div>
        <p
          className="text-18 text-descriptionText"
          dangerouslySetInnerHTML={{ __html: short_description[locale] }}
        ></p>
        <div className="flex items-center justify-between gap-5 flex-wrap">
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-3">
              <Image src={timeIcon} alt="Time Icon" />
              <div>
                <p className="text-16 text-darkText">
                  {locale === "ar" ? "تاريخ الانشاء" : "Creation Date"}
                </p>
                <p className="text-14 text-descriptionText">
                  {formatDate(created_at, locale)}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Image src={latestIcon} alt="Latest Icon" />
              <div>
                <p className="text-16 text-darkText">
                  {locale === "ar" ? "تاريخ الانشاء" : "Creation Date"}
                </p>
                <p className="text-14 text-descriptionText">
                  {formatDate(updated_at, locale)}
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Image src={viewIcon} alt="View Icon" />
            <p className="text-16 text-descriptionText font-[500]">
              {formatNumber(viewing_number)}{" "}
              {locale === "ar" ? "مشاهدة" : "View"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
